<template>
	<main class="payment-result">
		<div class="payment-result__inner _cnt">
			<div class="payment-result__title _md">
				{{
					$t(
						`Thank you - your payment was successful. You will shortly receive a confirmation to your e-mail. In case of any questions, please contact us at.`
					)
				}}
				<span>{{ this.footerSupportEmail }}</span>
			</div>
		</div>
	</main>
</template>
<script>
import { ButtonThemes } from '@/components/base/BaseButton.vue';
import { mapGetters } from 'vuex';

export default {
	name: 'PaymentSuccessPage',
	components: {},
	props: ['footerSupportEmail'],
	data() {
		return {
			ButtonThemes,
		};
	},
	computed: {
		...mapGetters('app', ['currencyCode']),
	},
	methods: {},
};
</script>

<style lang="scss" scoped>
@use '@/assets/styles/mixins' as *;
@use '@/assets/styles/media' as *;
@use '@/assets/styles/components/classes' as *;

.payment-result {
	@include header-indent;
	@include adaptiveValue('padding-top', 60, 25);
	@include adaptiveValue('padding-bottom', 60, 25);
	position: relative;
	min-height: calc(100vh - 98px);
	@media (max-width: $md1) {
		min-height: calc(100vh - 70px);
	}
	@media (max-width: $md4) {
		min-height: calc(100vh - 50px);
	}
	display: flex;
	align-items: center;
	&::before {
		content: '';
		position: fixed;
		width: 100%;
		height: 100%;
		top: 0;
		left: 0;
		background-image: url('@/assets/images/bg/vertical-bg.png');
		background-repeat: no-repeat;
		background-size: contain;
		background-size: 100% 100%;
		z-index: -1;
	}
	&__inner {
	}
	&__top {
		&:not(:last-child) {
			@include adaptiveValue('margin-bottom', 37, 20);
		}
		@media (min-width: $md5) {
			display: flex;
			justify-content: center;
			flex-wrap: wrap;
			gap: 20px;
		}
	}
	&__title {
		text-align: center;
		margin: 0 auto;
		span {
			color: var(--secondary-color);
		}
	}
	&__line {
		max-width: 710px;
		margin: 0 auto;
	}
}
</style>
